import { create } from "zustand";

export const useIQoroStore = create((set) => ({
  current_page: "user-verify",
  setCurrentPage: (current_page) =>
    set(() => ({
      current_page: current_page,
    })),

  date: null,
  setDate: (date) =>
    set(() => ({
      date: date,
    })),

  current_user: "",
  setCurrentUser: (user) =>
    set(() => ({
      current_user: user,
    })),

  token: "",
  setToken: (token) =>
    set(() => ({
      token: token,
    })),

  toaster_messages: [],
  setToasterMessage: (msg) =>
    set((state) => ({
      toaster_messages: [...state.toaster_messages, msg],
    })),

  show_toaster: false,
  setShowToaster: (b) =>
    set(() => ({
      show_toaster: b,
    })),

  show_users_switch: "all",
  setShowUsersSwitch: (s) =>
    set(() => ({
      show_users_switch: s,
    })),

  filter_users: "all",
  setFilterUsers: (f) =>
    set(() => ({
      filter_users: f,
    })),

  show_spinner: false,
  setShowSpinner: (show) =>
    set(() => ({
      show_spinner: show,
    })),

  last_sync: "",
  setLastSync: (date) =>
    set(() => ({
      last_sync: date,
    })),

  start_date: new Date(),
  setStartDate: (d) =>
    set(() => ({
      start_date: d,
    })),

  end_date: new Date(),
  setEndDate: (d) =>
    set(() => ({
      end_date: d,
    })),

  active_step: 0,
  setActiveStep: (s) =>
    set(() => ({
      active_step: s,
    })),

  transferred_files_ratio: 0,
  setTransferredFilesRatio: (ratio) =>
    set(() => ({
      transferred_files_ratio: ratio,
    })),

  iqoro_type_in_use: "real", //["real", "sim"]
  setIQoroTypeInUse: (type) =>
    set(() => ({
      iqoro_type_in_use: type,
    })),

  files_left_to_fetch: -1,
  setFilesLeftToFetch: (nr) =>
    set(() => ({
      files_left_to_fetch: nr,
    })),

  all_files_ids_to_fetch: [],
  setAllFilesIDsToFetch: (ids) =>
    set(() => ({
      all_files_ids_to_fetch: ids,
    })),

  files_successfully_uploaded: false,
  setFilesSuccessfullyUploaded: (ok) =>
    set(() => ({
      files_successfully_uploaded: ok,
    })),

  cp_characteristic: null,
  setCpCharacteristic: (char) =>
    set(() => ({
      cp_characteristic: char,
    })),

  bluetooth_device: null,
  setBluetoothDevice: (bt) =>
    set(() => ({
      bluetooth_device: bt,
    })),

  duration_level0: 1.5,
  setDurationLevel0: (d) =>
    set(() => ({
      duration_level0: d,
    })),

  duration_level1: 3,
  setDurationLevel1: (d) =>
    set(() => ({
      duration_level1: d,
    })),

  duration_level2: 7,
  setDurationLevel2: (d) =>
    set(() => ({
      duration_level2: d,
    })),

  force_level0: 2,
  setForceLevel0: (f) =>
    set(() => ({
      force_level0: f,
    })),

  force_level1: 5,
  setForceLevel1: (f) =>
    set(() => ({
      force_level1: f,
    })),

  force_level2: 11,
  setForceLevel2: (f) =>
    set(() => ({
      force_level2: f,
    })),
}));
